import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { DropdownRangeValuesComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

export interface RangeValue {
    from?: number | null;
    to?: number | null;
}

@Component({
    selector: 'app-dropdown-ranges-form-editor',
    templateUrl: './dropdown-ranges-form-editor.component.html',
    styleUrls: ['./dropdown-ranges-form-editor.component.scss'],
    providers: [createValueAccessorProvider(DropdownRangesFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DropdownRangeValuesComponent]
})
export class DropdownRangesFormEditorComponent extends FormEditorBase<RangeValue> {
    // Input signals
    value = input<RangeValue>();
    readonly = input<boolean>(false);
    placeholderText = input<string>();
    labelText = input<string>();
    minValue = input<number>();
    maxValue = input<number>();
    iconType = input<'dollar' | 'percentage' | 'number'>('number');

    // Internal signals for range values
    readonly valueFrom = signal<number | undefined>(undefined);
    readonly valueTo = signal<number | undefined>(undefined);

    constructor() {
        super();
    }

    onValueFromChange(value: number | undefined): void {
        this.valueFrom.set(value);
        this.emitChange();
    }

    onValueToChange(value: number | undefined): void {
        this.valueTo.set(value);
        this.emitChange();
    }

    onApplyClicked(): void {
        this.emitChange();
    }

    onClearClicked(): void {
        this.valueFrom.set(undefined);
        this.valueTo.set(undefined);
        this.emitChange();
    }

    // Override writeValue to sync with internal signals
    override writeValue(value: RangeValue): void {
        super.writeValue(value);
        this.valueFrom.set(value?.from || undefined);
        this.valueTo.set(value?.to || undefined);
    }

    protected override async onEntityTextChange(): Promise<void> {
        // Not needed for dropdown ranges
        return;
    }

    protected override mapSelectedItemsToValue(): RangeValue {
        return {
            from: this.valueFrom(),
            to: this.valueTo()
        };
    }

    protected override mapValueToSelectedItems(): any[] {
        return [];
    }

    private emitChange(): void {
        const value = this.mapSelectedItemsToValue();
        this.onChange(value);
        this.onTouched();
        this.valueChange.set(value);
    }
}
